/**
 * Umschalter „Meine“ / „Team“ über Terminlisten – auf der Startseite und in der
 * Projektübersicht. „Meine“ heißt: Ich bin verantwortlich. Derselbe Schalter wie im Abschnitt
 * Investitionskosten („Pro Anlage | Gesamt“).
 */
import React from "react";
import ToggleSwitch from "../../common/inputs/ToggleSwitch";
import { DeadlineScope } from "../../../services/api/deadlines";

interface ScopeToggleProps {
  value: DeadlineScope;
  onChange: (scope: DeadlineScope) => void;
}

const ScopeToggle: React.FC<ScopeToggleProps> = ({ value, onChange }) => (
  <ToggleSwitch
    value={value}
    options={[
      { value: "mine", label: "Meine" },
      { value: "team", label: "Team" },
    ]}
    onChange={(next) => onChange(next as DeadlineScope)}
  />
);

export default ScopeToggle;
